import React from 'react';
import MassEditModal from '../mass-edit-modal';
import { Form } from 'react-bootstrap';
import { useEditor } from '../mass-edit-modals';

export default () => {
    const editor = useEditor({
        getInitialValue: ({ name }) => ({ name }),
    })

    return (
        <MassEditModal
            title={`Edit ${editor.experiences.length} Titles`}
            onCancel={editor.onClose}
            onSave={editor.save}
            disabled={!editor.value.name}
            busy={editor.isBusy}
        >
            <Form.Group>
                <Form.Label>Title</Form.Label>
                <Form.Control
                    type="text"
                    value={editor.value.name}
                    onChange={e => editor.setValue({ name: e.target.value })}
                />
            </Form.Group>
        </MassEditModal>
    );
};
